import snackbar from 'components/snackbar';
import moment from 'moment';
import { calculateTotalFee, countAdults } from '../../../../utils';
import setLoading from 'components/loading';
import { submitApplication } from '../../../../utilities';

const setAcceptsJsScript = (property) => {
  const isAuthorize = property?.public_cc_processor?.processor === 'Authorize';

  // Add Authorize.net Accept.JS script if it doesn't already exist
  if (isAuthorize) {
    const { head } = document;
    const scripts = head.getElementsByTagName('script');
    const url = property?.public_cc_processor?.url;

    const candidates = Array.from(scripts).filter((script) => script.src === url);

    if (candidates.length == 0) {
      const script = document.createElement('script');
      script.src = url;
      document.head.appendChild(script);
    }
  }
};

const setAcceptsJsScriptPromise = (property) => new Promise((resolve, _reject) => {
  setAcceptsJsScript(property);
  setTimeout(() => { resolve(); }, 5000);
});

export default {
  'ModalBody.Container.AgreeSection.Field.Name': ({ value }, stateManager) => {
    stateManager.setLeaseholderName(value);
  },
  'ModalBody.Container.Buttons.Accept': async ({ cardDetails, property, paidFee, occupants }, stateManager) => {
    setLoading(true);

    const { login_id, public_key } = property?.public_cc_processor;
    const { cardNumber, cardCode, fullName, zip, expiration } = cardDetails;
    const { application_admin_fee, application_fee, agreement_text, additional_applicant_fee } = property;

    let [month, year] = expiration.split('/');
    month = month.padStart(2, '0');

    const timestamp = moment.utc();

    const secureData = {
      authData: {
        clientKey: public_key,
        apiLoginID: login_id
      },
      cardData: {
        cardNumber,
        month,
        year,
        cardCode,
        fullName,
        zip
      }
    };

    // Wait unit AcceptsJS script is loaded in DOM
    await setAcceptsJsScriptPromise(property);

    // Create token
    Accept.dispatchData(secureData, (response) => {
      // Accept.js tokenization fails
      if (response.messages.resultCode === 'Error') {
        const { code, text } = response.messages.message[0];
        let errMsg = `${code}: ${text}`;
        if (code === 'E_WC_20') {
          errMsg = 'Card number is invalid';
        }

        snackbar({
          message: errMsg,
          args: { type: 'error' }
        });

        setLoading(false);
        return;
      }

      // Create paymentData for submit aaplication payload
      const paymentData = {
        agreement_text,
        token_value: response.opaqueData.dataValue,
        token_description: response.opaqueData.dataDescriptor,
        agreement_accepted_at: timestamp,
        payment_type: 'cc',
        payer_name: fullName,
        source: 'customer-app-payment-form',
        last_4: cardNumber.slice(-4),
        amount: paidFee,
        fees: [
          {
            name: 'application_fees',
            amount: calculateTotalFee(property, occupants, false),
            baseFee: application_fee,
            numAdults: countAdults(occupants)
          },
          {
            name: 'admin_fees',
            amount: application_admin_fee
          }
        ]
      };
      submitApplication(stateManager, paymentData, property);
    });
  },
  'ModalBody.Container.Buttons.Cancel': ({ }, stateManager) => {
    stateManager.setPaymentAuthorization(false);
  }
};
